export function data(moveId, localState) {
  return localState[moveId];
}

export function hasData(moveId, localState) {
  return data(moveId, localState);
}

export function matches(moveId, localState) {
  return data(moveId, localState).matches.concat();
}

export function match(moveId, matchId, localState) {
  return matches(moveId, localState)
    .filter(match => match.id === matchId)
    .pop();
}

export function kind(moveId, localState) {
  return data(moveId, localState).kind;
}

export function isPremiumKind(moveId, localState) {
  return kind(moveId, localState) === 'premium';
}

export function firstName(moveId, localState) {
  return data(moveId, localState).first_name;
}

export function lastName(moveId, localState) {
  return data(moveId, localState).last_name;
}

export function email(moveId, localState) {
  return data(moveId, localState).email;
}

export function id(moveId, localState) {
  return data(moveId, localState).id;
}

export function matchMoveType(moveId, matchId, localState) {
  return match(moveId, matchId, localState).move_type;
}

export function hasRequestedOffer(moveId, matchId, localState) {
  return match(moveId, matchId, localState).requests.length > 0;
}
